export const CREATE_RFI = "api/rfi/" 
export const GET_RFI_LIST = "api/rfi/"
export const UPDATE_RFI = "api/rfi/id/{id}"
export const GET_RFI_BY_ID = "api/rfi/id/{id}"
export const GET_RFI_BY_USER = "api/rfi/user/{email}"
export const DELETE_RFI = "api/rfi/id/{id}"
export const MARK_RFI_AS_CLOSED = "api/rfi/mark_as_closed/{id}" 

